import { AdvicesService } from "@/api";

// state
const state = () => ({
	advices: [],
	lastCall: null
});

// getters
const getters = {};

// actions
const actions = {
  async getAll({ commit }) {
		// if (state.advices.length)
			// return true;

    const resp = await AdvicesService.getAll();
    const advices = resp;

    commit("setAdvicess", advices);
  },
};

// mutations
const mutations = {
  setAdvicess(state, advices) {
    state.advices = advices;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
